import { Author } from '@/lib/types';

import HygraphImage from '@/components/hygraph-image';
import Link from '@/components/link';
import Typography from '@/components/typography';

import { Side } from '@/enums/side';

export default function AuthorShortBio(props: Author) {
  return (
    <div className='layout w-full pt-8'>
      <div className='relative flex items-center py-5'>
        <div className='flex-grow border-t text-gray-900'></div>
      </div>
      <Typography.Heading3>Author profile</Typography.Heading3>
      <div className='pt-8 lg:grid lg:grid-cols-12 lg:gap-8'>
        <div className='col-span-9 flex flex-col items-start gap-8 md:flex-row md:gap-0'>
          <div className='flex-none overflow-hidden rounded-t text-center lg:h-auto lg:rounded-l lg:rounded-t-none'>
            {props.profileImage && (
              <HygraphImage
                url={props.profileImage.url}
                layout='responsive'
                width={300}
                height={300}
                className='h-44 w-44 overflow-hidden rounded-full object-cover md:h-36 md:w-36 lg:h-44 lg:w-44'
              />
            )}
          </div>
          <div className='flex flex-col bg-white pb-4 leading-normal md:pl-6'>
            <Typography.Body2 className='mb-2' weight='bold'>
              {props.name}
            </Typography.Body2>
            <Typography.Body2 className='leading-6'>
              {props.shortBio}
            </Typography.Body2>
            {props.linkedInProfile && (
              <p className='pt-4 text-primary'>
                <Link
                  href={props.linkedInProfile}
                  icon={<LinkedInIcon />}
                  iconPosition={Side.LEFT}
                  className='inline-flex'
                >
                  {props.linkedInProfile}
                </Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const LinkedInIcon = () => (
  <svg
    style={{
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: 10,
    }}
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M26 0H1.9375C0.875 0 0 0.9375 0 2.0625V26C0 27.125 0.875 28 1.9375 28H26C27.0625 28 28 27.125 28 26V2.0625C28 0.9375 27.0625 0 26 0ZM8.4375 24H4.3125V10.6875H8.4375V24ZM6.375 8.8125C5 8.8125 3.9375 7.75 3.9375 6.4375C3.9375 5.125 5 4 6.375 4C7.6875 4 8.75 5.125 8.75 6.4375C8.75 7.75 7.6875 8.8125 6.375 8.8125ZM24 24H19.8125V17.5C19.8125 16 19.8125 14 17.6875 14C15.5 14 15.1875 15.6875 15.1875 17.4375V24H11.0625V10.6875H15V12.5H15.0625C15.625 11.4375 17 10.3125 19 10.3125C23.1875 10.3125 24 13.125 24 16.6875V24Z'
      fill='#0682A3'
    />
  </svg>
);
